import SelectPartReplacementModal from '@/components/Operational/Inventory/Parts/PartReplacementPartsForm/SelectPartReplacementModal';
import { usePartMutation } from '@/core/domain/operational/Parts/Parts.hooks';
import { Part } from '@/core/domain/operational/Parts/Parts.types';
import { useDisclosure } from '@/hooks';
import { Form, InputProps } from 'antd';
import { useEffect } from 'react';
import InputSearch from '../InputSearch';

type Props = InputProps & {
  onPartSelect: (part: Part) => void;
  fieldNameId: string;
};

const PartsInputSearch: React.FC<Props> = ({
  onPartSelect,
  fieldNameId,
  ...props
}) => {
  const [modalOpened, modalAction] = useDisclosure();
  const form = Form.useFormInstance();
  const partId = Form.useWatch(fieldNameId, form);

  const { mutateAsync: getPart, isLoading } = usePartMutation();

  useEffect(() => {
    if (partId) {
      getPart(partId).then((part) =>
        form.setFieldValue('insurerName', part.name),
      );
    }
  }, [partId]);

  return (
    <>
      <InputSearch
        {...props}
        inputProps={{ disabled: true }}
        buttonProps={{ onClick: modalAction.open, loading: isLoading }}
      />

      <SelectPartReplacementModal
        isModalVisible={modalOpened}
        setIsModalVisible={modalAction.toggle}
        handlerOnOkay={modalAction.close}
        handlerPartSelect={(part) => {
          onPartSelect(part);
          modalAction.close();
        }}
      />
    </>
  );
};

export default PartsInputSearch;
